import { put, call } from 'redux-saga/effects';
import { fetchWithMisToken } from '../../../../utils/fetch-with-mis-token';
import { FETCH_FEATURED_HEAD_TO_HEAD, setFeaturedHeadToHead } from '../actions';

/**
 * @typedef {object} fetchFeaturedHeadToHeadAction
 * @property {object} payload
 * @property {string} payload.seasonId
 */

/**
 * @param {fetchFeaturedHeadToHeadAction} action - The Redux action.
 */
export function* fetchFeaturedHeadToHead(action) {
    const { seasonId } = action.payload;

    let data = {};

    data = yield call(
        fetchWithMisToken,
        `${PULSE.app.environment.statsPro}/playerHeadToHead/featured?seasonId=${seasonId}`
    );

    yield put(setFeaturedHeadToHead(data));

    yield put(FETCH_FEATURED_HEAD_TO_HEAD.success(data));
}
